import { useState } from 'react'
import LeftPane from './LeftPane'
import RightPane from './RightPane'
import TwoColumn from '../../layouts/TwoColumn'

function KitchenSink() {
  const [selectedSection, setSelectedSection] = useState<string>('basicControls')

  return (
    <TwoColumn
      layoutId="kitchenSink"
      leftPane={<LeftPane selectedSection={selectedSection} onSectionChange={setSelectedSection} />}
      rightPane={<RightPane selectedSection={selectedSection} />}
      minLeftWidth={15}
      minRightWidth={40}
    />
  )
}

export default KitchenSink
